import { Card, Divider, Row, Tag, Typography } from 'antd';
import moment from 'moment';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { eventTypes, general } from 'configs';
import userIcon from 'images/users.svg';
import { paths } from 'configs/paths';

const { Meta } = Card;
const { Text } = Typography;
const { displayDate } = general;
const { dashboard } = paths;

const EventCard = ({ event }) => {
  const { push } = useHistory();
  const { start_date, last_registration_date, event_type, avatar_url, id, name } = event;
  const startDate = moment(start_date).format(displayDate);
  const lastRegistrationDate = moment(last_registration_date).format(displayDate);

  const eventDescription = (
    <>
      <Row>
        <img src={userIcon} className="mr-2" alt="user icon" />
        <Tag color="#3ddbb6">{eventTypes[event_type] || '-'}</Tag>
      </Row>
      <Divider />
      <Row>
        <Text>
          <Text strong>Fecha de inicio </Text>
          {startDate}
        </Text>
      </Row>
      <Row>
        <Text>
          <Text strong>Última fecha de inscripción </Text>
          {lastRegistrationDate}
        </Text>
      </Row>
    </>
  );

  return (
    <Card
      cover={
        <div
          className="rounded-t-lg overflow-hidden h-56 bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${avatar_url})`,
          }}
        />
      }
      hoverable
      onClick={() => push(dashboard.event(id))}
    >
      <Meta title={name} description={eventDescription} />
    </Card>
  );
};

export default EventCard;
